import React, { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import styles from './ElementData.styles';

interface ElementDataSectionProps {
    children?: ReactNode;
    title?: string;
    adjustableDisplayTitle?: boolean;
    order?: number;
}
export default function ElementDataSection(props: ElementDataSectionProps) {
    const { children, title, order, adjustableDisplayTitle = true } = props;

    return (
        <Box sx={{ ...styles.section, order: order }} className={`element-data-section`}>
            {title && (
                <Box
                    sx={styles.sectionHeader}
                    className={`element-data-section__header ${adjustableDisplayTitle ? 'element-data-section__header--adjustable' : ''}`}
                >
                    {title}
                </Box>
            )}
            <Stack width={'100%'} sx={styles.sectionRowsHolder} className={'element-data-section__rows-holder'}>
                {children}
            </Stack>
        </Box>
    );
}
